import React from "react"
import { Global } from "@emotion/react"
import css from "@styled-system/css"

const GlobalStyles = () => (
  <Global
    styles={css({
      "*": { boxSizing: "border-box" },
      body: {
        m: 0,
        fontFamily: "standard",
        color: "text",
        bg: "background",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      },
      a: {
        textDecoration: "none",
        color: "inherit",
      },
    })}
  />
)

export default GlobalStyles
